<template>
  <ul class="team__list" v-if="teamMembers && teamMembers.length">
    <li class="team__list-item" v-for="member in teamMembers" :key="member.name">
      <div class="team__list-item-inner">
        <div class="team__list-item-image" :style="{ backgroundImage: `url(${member.image})` }"></div>
        <svg class="team__list-item-image-svg">
          <clipPath id="my-clip-path" clipPathUnits="objectBoundingBox">
            <path d="M0.372,0 c0.079,0,0.157,0,0.236,0 c0.012,0.001,0.024,0.003,0.035,0.004 c0.068,0.006,0.136,0.01,0.202,0.019 C0.9,0.03,0.94,0.058,0.96,0.105 c0.012,0.029,0.021,0.059,0.027,0.089 c0.007,0.034,0.008,0.069,0.012,0.103 c0,0.014,0,0.027,0,0.041 c-0.004,0.044,-0.007,0.088,-0.012,0.132 c-0.014,0.114,-0.034,0.227,-0.068,0.337 c-0.029,0.095,-0.093,0.158,-0.198,0.181 c-0.023,0.005,-0.047,0.008,-0.07,0.012 c-0.052,0,-0.104,0,-0.156,0 c-0.004,-0.001,-0.009,-0.003,-0.013,-0.003 c-0.065,-0.005,-0.13,-0.009,-0.195,-0.016 c-0.061,-0.007,-0.122,-0.016,-0.178,-0.044 c-0.031,-0.016,-0.053,-0.037,-0.062,-0.069 c-0.008,-0.027,-0.017,-0.055,-0.019,-0.083 c-0.01,-0.12,-0.017,-0.24,-0.025,-0.36 C0.002,0.402,0.001,0.379,0,0.356 c0,-0.025,0,-0.049,0,-0.074 c0.003,-0.021,0.005,-0.043,0.008,-0.064 c0.014,-0.083,0.058,-0.146,0.142,-0.179 C0.191,0.023,0.236,0.016,0.279,0.008 C0.31,0.002,0.341,0.003,0.372,0"></path>
          </clipPath>
        </svg>
        <p v-if="member.name" class="team__list-item-name">{{ member.name }}</p>
        <p v-if="member.title" class="team__list-item-job-title">{{ member.title }}</p>
      </div>
    </li>      
  </ul>

  <div class="btn-center" v-if="canShowMore">
    <button class="btn btn-blue btn-medium btn-rounded" @click="doLoadMore">Load more</button>
  </div>
</template>

<script>
  export default {
    name: 'Team',

    props: {
      payload: {
				type: [Array,String]
			},
    },
		
   	data() {
      return {
        teamMembers: false,
        teamMembersToShow: 4,
        canShowMore: false
      }
    },

    created() {
      this.allTeamMembers = typeof this.payload == 'string' ? JSON.parse(this.payload) : this.payload;
      this.teamMembers = this.allTeamMembers.splice(0, this.teamMembersToShow);
    },

    methods: {
      doLoadMore() {
        if (this.canShowMore) {
          this.teamMembers = this.teamMembers.concat(this.allTeamMembers.splice(0, this.teamMembersToShow));
          this.canShowMore = this.allTeamMembers.length > 0;
        }
	    }
    },
  };
</script>
